import { palette } from '../constants/colors';
import { buildTooltipLabel } from './chartHelpers';

const tooltipBase = {
    padding: 10,
    bodyFont: { size: 12 },
    titleFont: { size: 13, weight: 'bold' as const },
    backgroundColor: palette.dark,
    titleColor: palette.white,
    bodyColor: palette.white,
    borderColor: palette.gray_200,
    borderWidth: 0,
    callbacks: { label: buildTooltipLabel() },
};

const cartesianAxis = {
    grid: { display: false, color: palette.gray_200 },
    ticks: { font: { size: 10 }, maxRotation: 0, autoSkip: true, color: palette.gray_600 },
};

export const lineDefaults: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: false },
        tooltip: { enabled: true, ...tooltipBase },
    },
    scales: {
        x: { ...cartesianAxis, display: true, ticks: { ...cartesianAxis.ticks, maxTicksLimit: 7 } },
        y: { ...cartesianAxis, display: true, ticks: { ...cartesianAxis.ticks, maxTicksLimit: 5 } },
    },
    elements: { line: { tension: 0.4 }, point: { radius: 3, hoverRadius: 5 } },
};

export const barDefaults: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: false },
        tooltip: { ...tooltipBase },
    },
    scales: {
        x: { ...cartesianAxis },
        y: { ...cartesianAxis, ticks: { ...cartesianAxis.ticks, maxTicksLimit: 5 } },
    },
};

export const circularDefaults: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
        legend: { display: false },
        tooltip: { ...tooltipBase },
    },
};

export const pieDefaults: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: false },
        tooltip: { ...tooltipBase },
    },
};

export const radarDefaults: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: false },
        tooltip: { ...tooltipBase },
    },
    scales: {
        r: {
            angleLines: { color: palette.gray_200 },
            grid: { display: true, color: palette.gray_200 },
            pointLabels: { font: { size: 10 }, color: palette.gray_600 },
            ticks: { display: false },
        },
    },
};

export const polarDefaults: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: false },
        tooltip: { ...tooltipBase },
    },
    scales: {
        r: {
            angleLines: { color: palette.gray_200 },
            grid: { display: true, color: palette.gray_200 },
            ticks: { display: false },
        },
    },
};

export const legendBottom = {
    display: true,
    position: 'bottom' as const,
    align: 'center' as const,
    labels: {
        boxWidth: 10,
        padding: 12,
        font: { size: 12, weight: '500' as const },
        usePointStyle: true,
        color: palette.gray_600,
    },
};

export const legendBottomCompact = {
    display: true,
    position: 'bottom' as const,
    labels: { boxWidth: 8, font: { size: 10 }, color: palette.gray_600 },
};
